import { useMutation } from "@apollo/client";
import { Form, Formik } from "formik";
import gql from "graphql-tag";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { Button } from "../../SharedComponents/Button/Button";
import { FormInput } from "../../SharedComponents/FormInput/FormInput";
import "./LoginRequestPasswordReset.css";
import { LoginRequestPasswordResetSuccess } from "./LoginRequestPasswordResetSuccess/LoginRequestPasswordResetSuccess";

export const LoginRequestPasswordReset = () => {
  const { t } = useTranslation();
  const [resetPassword, { loading }] = useMutation(passwordResetMutation);

  const [successDisplay, setSuccessDisplay] = useState(false);

  const passwordResetHandler = async (email) => {
    resetPassword({ variables: { email } })
      .then(() => {
        setSuccessDisplay(email);
      })
      .catch(() => {
        setSuccessDisplay(email);
      });
  };

  return (
    <div className="LoginRequestPasswordReset">
      {!successDisplay && (
        <Formik
          initialValues={{ email: "" }}
          onSubmit={(values) => passwordResetHandler(values.email)}
          validationSchema={validationSchema}
        >
          {() => (
            <Form>
              <FormInput
                // @ts-ignore
                name="email"
                type="text"
                label={t("generic.email")}
              />
              <div className="LoginForm__submit">
                <Link to="/login">
                  <div className="LoginForm__forgotten-password">
                    {t("generic.back")}
                  </div>
                </Link>
                <div className="LoginForm__submit-button">
                  <Button
                    buttonStyle="Button__primary"
                    type="submit"
                    disabled={loading}
                  >
                    {t("generic.reset")}
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      )}
      {successDisplay && (
        <LoginRequestPasswordResetSuccess email={successDisplay} />
      )}
    </div>
  );
};

const validationSchema = Yup.object().shape({
  email: Yup.string().email("errors.invalidEmail").required(),
});

const passwordResetMutation = gql`
  mutation requestSSOUserPasswordReset($email: String) {
    requestSSOUserPasswordReset(email: $email)
  }
`;
